//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("pscisRequest", PscisRequestFactory);

    PscisRequestFactory.$inject = ["apiClientFactory"];
    function PscisRequestFactory(apiClientFactory) {

        const routePrefix = "api/pscis/";

        return {
            AcceptRequest: apiClientFactory.patch(routePrefix + "requests/accept/"),
            AddComment: apiClientFactory.post(routePrefix + "request-comments/"),
            Delete: apiClientFactory.get(routePrefix + "requests/delete/"),
            Export: apiClientFactory.post(routePrefix + "requests/export/"),
            FinishRequest: apiClientFactory.patch(routePrefix + "requests/finish/"),
            Get: apiClientFactory.get(routePrefix + "requests/"),
            GetComments: apiClientFactory.post(routePrefix + "comments/"),
            GetCompletedUnsignedPscisForm: apiClientFactory.post(routePrefix + "get-completed-unsigned-pscis-form/"),
            GetNew: apiClientFactory.get(routePrefix + "requests/new/"),
            GetPscisPartners: apiClientFactory.post(routePrefix + "pscis-partners/"),
            RecallRequest: apiClientFactory.get(routePrefix + "requests/recall/"),
            RejectRequest: apiClientFactory.patch(routePrefix + "requests/reject/"),
            ReturnRequest: apiClientFactory.put(routePrefix + "requests/return/"),
            Save: apiClientFactory.patch(routePrefix + "requests/save/"),
            SaveRequestValidation: apiClientFactory.put(routePrefix + "save-validation/"),
            SearchRequests: apiClientFactory.post(routePrefix + "requests/"),
            Submit: apiClientFactory.patch(routePrefix + "requests/submit/"),
            SubmitRequestList: apiClientFactory.post(routePrefix + "requests/submitrequestlist/"),
            UploadAttachments: apiClientFactory.post(routePrefix + "upload-attachments/"),
        };
    }
})();
